function Menu(options) {
    this.defaults = {
    };
    this.breadcrumbs = [];
    $.extend(this.defaults, options);
    this.init();
}

Menu.prototype.init = function() {
    var self = this;
    if (!Foundation.utils.is_large_up() && $('body').hasClass('-home')) {
        $('.header').removeClass('-menu-open');
    }
    self.menuOpen = $('.header').hasClass('-menu-open');
    self.menuOverlay = false;
    setTimeout(function(){
        $('.header').addClass('-animated');
    },100);
    // $('.menu-button').click(function() {
    //     self.toggleMenu();
    // });

    function toggleMenuClasses() {
        $('body').toggleClass('-menu-open');
        $('.main-menu').toggleClass('-active');
        $('.search').toggleClass('-visible');
        $('.select-menu').toggleClass('-visible');
        $('.menu-button').toggleClass('-active');
    }

    $('body, .main-menu').on('keydown', function(e) {
        if(e.key == "Escape") {
            if($('.menu-button').hasClass('-active')) {
                toggleMenuClasses();
                $('.menu-button').focus();
            }
        }
    });
    $('.menu-button').on('click keydown', function(e) {
        if(!e.key || e.key == "Enter") {
            toggleMenuClasses();
            
            if($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        }
    });
    $('.subdomain-menu-button').on('click', function(e) {
        e.stopPropagation();
        $('body').toggleClass('-menu-open');
        if ($(this).hasClass('-active')) {
            $('.subdomain-menu').removeClass('-active');
            $('.subdomain-menu li').removeClass('-active');
            $(this).removeClass('-active');
        } else {
            $('.subdomain-menu').addClass('-active');
            $(this).addClass('-active');
        }
    });

    $('.footer-subdomain-menu-button').on('click', function(e) {
        e.stopPropagation();
        $('body').toggleClass('-menu-open');
        if ($(this).hasClass('-active')) {
            $('.footer-subdomain-menu').removeClass('-active');
            $('.footer-subdomain-menu li').removeClass('-active');
            $(this).removeClass('-active');
        } else {
            $('.footer-subdomain-menu').addClass('-active');
            $(this).addClass('-active');
        }
    });
    
    $('.subdomain-menu li:not(.menu__label), .footer-subdomain-menu li:not(.menu__label)').on('click', function(e) {
        e.stopPropagation();
        self.menuButtonPress($(this));
    });
    $('.subdomain-menu .menu__label, .footer-subdomain-menu .menu__label').on('click keypress', function(e) {
        if (e.type == 'click' || e.key == 'Enter') {
            e.stopPropagation();
            if ($(this).closest('.menu-label-column').closest('li:not(.menu-columns-container)').length) {
                $(this).closest('.menu-label-column').closest('li:not(.menu-columns-container)').removeClass('-active');
            } else {
                $('.subdomain-menu').removeClass('-active');
                $('.subdomain-menu-button').removeClass('-active');
                $('.footer-subdomain-menu').removeClass('-active');
                $('.footer-subdomain-menu-button').removeClass('-active');
            }
        }
    });
    $('.subdomain-menu, .footer-subdomain-menu').on('click', function(e) {
        e.stopPropagation();
    });

    $('.main-menu li:not(.menu__label)').on('click', function(e) {
        e.stopPropagation();
        self.menuButtonPress($(this));
    });
    $('.main-menu .menu__label').on('click keypress', function(e) {
        if (e.type == 'click' || e.key == 'Enter') {
            e.stopPropagation();
            self.menuButtonPress($(this).closest('.menu-label-column').closest('li:not(.menu-columns-container)'));
        }
    });
    $('.main-menu').on('keydown', function(e) {
        if (e.key == 'Escape') {
            e.stopPropagation();
            e.preventDefault();
            var $activeLabel = $('.menu__item.-active').last().find('.menu__label').first();
            $activeLabel.click();
            setTimeout(function() {
                $activeLabel.focus();
            }, 50);
        }
    });

    // $('.main-menu ul[data-level="0"] > li > a').hoverIntent(
    //     function() {
    //         self.menuButtonPress($(this).closest('li'), 1);
    //     }, function() {}
    // );

    $('.secondary-menu').on('click', function(e) {
        e.stopPropagation();
    });

    $(document).on('click', function(e) {
        self.menuButtonPress($('.main-menu ul li.-active'));
        $('.subdomain-menu').removeClass('-active');
        $('.subdomain-menu-button').removeClass('-active');
        $('.footer-subdomain-menu').removeClass('-active');
        $('.footer-subdomain-menu-button').removeClass('-active');
    });


    $('.main-menu a, .subdomain-menu a, .footer-subdomain-menu a').click(function(e) {
        if ($(this).attr('href') == "#")
            e.preventDefault();
    });

    $('.header-breadcrumbs__container').on('click', 'a[href="#"]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.main-menu li').removeClass('-active');
        var id = $(this).parent().attr('data-id');
        if (id) {
            var target = $('.main-menu').find('li[data-id="'+id+'"]');
            var button = target.closest('li:not(.menu-columns-container)');
            self.showMenu();
            self.menuButtonPress(button);
            self.populateMenuOverlay(target);
            if (button.attr('data-level') != '0') {
                button = target.closest('li[data-level="0"]');
                self.menuButtonPress(button);
                self.populateMenuOverlay(target);
            }
        }
    });
    self.breadcrumbsTarget = $('.header-breadcrumbs__container');
    self.breadcrumbsHtml = self.breadcrumbsTarget.html();
    self.breadcrumbs.push(self.breadcrumbsTarget.find('li').first());
};

Menu.prototype.toggleMenu = function() {
    var self = this;
    if (self.menuOpen)
        self.hideMenu();
    else
        self.showMenu();
};

Menu.prototype.showMenu = function() {
    var self = this;
    if (Foundation.utils.is_small_only() || Foundation.utils.is_medium_only())
        $('html, body').animate({scrollTop: 0}, 0);
    // app.search.hideSearch();
    $('.header').addClass('-menu-open');
    self.menuOpen = true;
};

Menu.prototype.hideMenu = function() {
    var self = this;
    $('.header').removeClass('-menu-open');
    $('.header').removeClass('-menu-overlay');
    // $('.main-menu li[data-level="0"]').removeClass('-selected');
    $('body').removeClass('-no-scroll-large');
    self.menuOpen = false;
    if (self.menuOverlay)
        self.hideMenuOverlay();
};

Menu.prototype.toggleMenuOverlay = function() {
    var self = this;
    if (self.menuOverlay)
        self.hideMenuOverlay();
    else
        self.showMenuOverlay(); 
};

Menu.prototype.showMenuOverlay = function() {
    var self = this;
    $('.header').addClass('-menu-overlay');
    $('body').addClass('-no-scroll-large');
    self.menuOverlay = true;
};

Menu.prototype.hideMenuOverlay = function() {
    var self = this;
    $('.header').removeClass('-menu-overlay');
    $('body').removeClass('-no-scroll-large');
    $('.header-breadcrumbs__container').html(self.breadcrumbsHtml);
    self.menuOverlay = false;
};

Menu.prototype.populateMenuOverlay = function(target,direction) {
    var self = this;
    var element = target.find('>ul');
    var html = element.wrap('<p/>').parent().html();
    element.unwrap();
    if (html) {
        $('.header .secondary-menu').empty().append('<div class="row"><div class="column">'+html+'</div></div>');
        var list = $('.header .secondary-menu ul:not(.top-label)').first();
        var dataLevel = parseInt(list.attr('data-level'));
        // list.find('li').removeClass('-selected');
        if (direction !== undefined) {
            var k = setTimeout(function() {
                $('.header .secondary-menu > .row > .column > ul').addClass('-animate-out');
            }, 20);
            self.breadcrumbs.splice(dataLevel+1,self.breadcrumbs.length);
            self.breadcrumbsRender();
        } else {
            self.breadcrumbs.splice(dataLevel,self.breadcrumbs.length);
            self.breadcrumbsPush(target.wrap('<p/>').parent().html());
            target.unwrap();
            self.breadcrumbsRender();
        }
        if (dataLevel >= 2) {
            // tu trzeba zrobic nazwe wezla o jeden wyzszego
            list.parent().prepend('<ul class="top-label"><li data-back="'+target.attr('data-id')+'"><a href="#"><b>'+target.find('a').first().text()+'</b></a></li></ul>');
        }
        var t = setTimeout(function() {
            $('.header .secondary-menu > .row > .column > ul').addClass('-animate-in');
        },50);
        $('.header .secondary-menu li').on('click',function(e) {
            e.stopPropagation();
            if ($(this).attr('data-back') !== undefined) {
                self.populateMenuOverlay($('.main-menu li[data-id="'+target.attr('data-id')+'"]').parent().parent(),1);
            }
            else {
                self.populateMenuOverlay($(this));
            }
        });
        $('.header .secondary-menu li a').click(function(e) {
            if ($(this).attr('href') == "#") {
                e.preventDefault();
            }
        });
    }
};

Menu.prototype.menuButtonPress = function(target, hover) {
    var self = this;
    var active = target.hasClass('-active');
    var selected = target.hasClass('-selected');
    var hovered = hover ? 1 : 0;
    if (target.attr('data-level') === "0") {

        $('header.header').removeClass('-pink');
        $('header.header').removeClass('-red');
        $('header.header').removeClass('-blue');
        $('header.header').removeClass('-greenblue');
        
        // if (!Foundation.utils.is_large_up())
            // target.toggleClass('-active');
        // else {
            // if (selected) {
                // target.removeClass('-selected');
                // target.removeClass('-active');
                // self.hideMenuOverlay();
            // } else {
                // target.addClass('-active');
                // target.siblings().removeClass('-active');
                // if (target.find('ul').length) {
                //     // target.addClass('-selected');
                //     // target.siblings().removeClass('-selected');
                //     self.populateMenuOverlay(target);
                //     self.showMenuOverlay();
                // }
            // }
        // }
        // if (hovered) {
        //     target.addClass('-active');
        //     target.siblings().removeClass('-active');
        // } else {
        //     target.toggleClass('-active');
        //     target.siblings().removeClass('-active');
        // }
        if (!active) {
            var color = target.attr('data-color');
            if (target.find('.secondary-menu').length) {
                $('header.header').addClass(color);
                setTimeout(function() {
                    target.find('.menu__label').first().focus();
                }, 100);
            }
        }
    }
    if (active) {
        if (target.attr('data-level') === "0") {
            $('.main-menu ul li').removeClass('-active').find('> a').attr('aria-expanded', 'false');
            setTimeout(function() {
                target.find('a[role="menuitem"]').first().focus();
            }, 100);
        } else {
            target.removeClass('-active').find('> a').attr('aria-expanded', 'false');
            setTimeout(function() {
                target.find('> a').first().focus();
            }, 100);
        }
    } else {
        target.siblings().removeClass('-active');
        target.siblings().find('.-active').removeClass('-active');
        target.addClass('-active').find('> a').attr('aria-expanded', 'true');
        if (target.attr('data-level')) {
            this.handleFocusTrap(target.find('*[role="menu"]'));
            setTimeout(function() {
                target.find('*[role="menuitem"]').first().focus();
            }, 100);
        }
    }
};

Menu.prototype.breadcrumbsPush = function(source) {
    var self = this;
    self.breadcrumbs.push(source);
};

Menu.prototype.breadcrumbsPop = function(source) {
    var self = this;
    self.breadcrumbs.pop();
};

Menu.prototype.breadcrumbsRender = function() {
    var self = this;
    self.breadcrumbsTarget.empty();
    for (var i in self.breadcrumbs) {
        self.breadcrumbsTarget.append(self.breadcrumbs[i]);
    }
    self.breadcrumbsTarget.find('li').click(function(e) {
        e.stopPropagation();
        self.populateMenuOverlay($(this),1);
    });
    self.breadcrumbsTarget.find('a').click(function(e) {
        e.preventDefault();
        if ($(this).attr('href') == "#") {
            e.preventDefault();
        }
    });
};

Menu.prototype.handleFocusTrap = function(elem) {
    var $first = elem.find('.menu__label').first();
    var $last = elem.find('.menu-items-column').first().find('> .menu__item').last().find('> a');

    $first.on('keydown', function(e) {
        if(e.key == "Tab" && e.shiftKey) {
            e.preventDefault();
            $last.focus();
        }
    });
    $last.on('keydown', function(e) {
        if(e.key == "Tab" && !e.shiftKey) {
            e.preventDefault();
            $first.focus();
        }
    });
};